export default {"src":"/_next/static/media/shopping-cart.bf894c6b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};